/**
 * Quote moderation scenarios (Admin Quotes).
 * Parent Quote (QTE-####) contains Quote Threads (QTH-####).
 * Quote Request (QREQ-####) may link to one or more Quotes.
 */

const quoteScenarios = [
  // Scenario 1 — Medium case → Under Review | Get Quotes
  {
    scenarioKey: 1,
    name: 'Harassment After Quote Submission',
    quote: {
      quoteId: 'QTE-8011',
      quoteRequestId: 'QREQ-8011',
      recipientMatchId: 'QMR-0001',
      requestSource: 'Get Quotes',
      title: 'Drainage Issue Near Backyard',
      description:
        'Standing water and soft ground near rear drainage line after heavy rain. Quote for inspection and repair options.',
      location: 'Point Cook VIC 3030',
      submittedAt: '2026-01-30T01:00:00.000Z',
      deliveredAt: '2026-01-30T01:01:00.000Z',
      lastUpdated: '2026-01-30T08:22:00.000Z',
      customerId: 'CUS-4419',
      businessId: 'BUS-6027',
      attachmentsSummary: 'Image 1 — Yard drainage area; Image 2 — Downpipe outlet',
      containsMedia: true,
      quoteRequestStatus: 'Distributed',
      responseStatus: 'Responded',
      snapshot: {
        formRecord: 'Quote Request Form',
        formVersion: 'Version 3',
        quoteTitle: 'Drainage Issue Near Backyard',
        jobDescription:
          'Standing water and soft ground near rear drainage line after heavy rain. Quote for inspection and repair options.',
        tradeCategory: 'Plumbing',
        subcategory: 'Drainage',
        jobLocation: 'Point Cook VIC 3030',
        selectedQuoteRadius: '10 km',
        attachments: ['yard-drainage.jpg', 'downpipe-outlet.jpg'],
        submittedOn: '2026-01-30T01:00:00.000Z',
      },
      distribution: {
        recipientMatchId: 'QMR-0001',
        matchingRuleId: 'QMD-0001',
        allocationType: 'Pro',
        planAtMatchingTime: 'Pro',
        deliveryStatus: 'Delivered',
        matchingRunOn: '2026-01-30T01:01:00.000Z',
        appliedRuleSettings: {
          conditions: ['Is Plumbing', 'Quote History of 90 days'],
          maximumBusinesses: '5',
          proBusinesses: '3',
          basicBusinesses: '1',
          bestMatch: '1',
          defaultQuoteRadius: '10 km',
          distributionMethod: 'Simultaneous',
        },
      },
    },
    chatMessages: [
      { id: 'QTH-8011', sender: 'Customer', senderId: 'CUS-4419', text: 'Please confirm whether site access is available this Friday.', timestamp: '2026-01-30T08:16:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T08:16:30.000Z', visibility: 'Visible', isFlagged: false, isQuoteRequest: true },
      { id: 'QTH-8012', sender: 'Business', senderId: 'BUS-6027', text: 'Friday works — I can be on site between 9–11 am. Side gate code noted from your form.', timestamp: '2026-01-30T08:17:30.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T08:18:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8013', sender: 'Customer', senderId: 'CUS-4419', text: 'Great. Dogs will be inside — just holler at the door when you arrive.', timestamp: '2026-01-30T08:18:15.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T08:18:45.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8014', sender: 'Business', senderId: 'BUS-6027', text: 'Will do. I will bring CCTV pipe cam — expect mud near the soak zone.', timestamp: '2026-01-30T08:19:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T08:19:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8015', sender: 'Customer', senderId: 'CUS-4419', text: 'Thanks — storm last week made it worse so sooner is better.', timestamp: '2026-01-30T08:20:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T08:20:20.000Z', visibility: 'Visible', isFlagged: true },
      { id: 'QTH-8016', sender: 'Business', senderId: 'BUS-6027', text: 'Understood. After inspection I will outline trench vs relining options same day.', timestamp: '2026-01-30T08:21:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T08:21:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8017', sender: 'Customer', senderId: 'CUS-4419', text: 'Perfect. Send quote whenever ready.', timestamp: '2026-01-30T08:22:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T08:22:30.000Z', visibility: 'Visible', isFlagged: false },
    ],
    customer: {
      customerId: 'CUS-4419',
      name: 'Michael Turner',
      memberSince: '2023-11-20',
      lastActive: '2026-01-30T08:20:00.000Z',
      accountStatus: 'Active',
      blockStatus: 'Not blocked',
    },
    business: {
      businessId: 'BUS-6027',
      businessName: 'PrimeFlow Plumbing',
      category: 'Plumbing',
      verificationStatus: 'Verified',
      accountStatus: 'Active',
      blockStatus: 'Not blocked',
      memberSince: '2023-02-15',
    },
    flag: {
      flagId: 'FLG-55101',
      source: 'Business Flag',
      flaggedBy: 'PrimeFlow Plumbing',
      quoteThreadId: 'QTH-8015',
      category: 'Moderation',
      trigger: 'Abusive messages in quote chat',
      reason: 'Abusive messages in quote chat',
      severity: 'Medium',
      status: 'Under Review',
      linkedCaseId: 'MOD-000551',
      createdAt: '2026-01-30T08:25:00.000Z',
      updatedAt: '2026-01-30T08:25:00.000Z',
    },
    case: {
      caseId: 'MOD-000551',
      contentType: 'Quote',
      severity: 'Medium',
      status: 'Under Review',
      assignedTo: 'Alex Chen',
      created: '2026-01-30T08:25:00.000Z',
      updated: '2026-01-30T08:25:00.000Z',
    },
    messagingState: 'Active',
    adminNote: 'Customer message flagged. Case under review.',
  },

  // Scenario 2 — High case → Under Review | Post
  {
    scenarioKey: 2,
    name: 'Off-Platform / Policy Bypass',
    quote: {
      quoteId: 'QTE-8018',
      quoteRequestId: 'QREQ-8018',
      recipientMatchId: 'QMR-0002',
      requestSource: 'Post',
      title: 'Bathroom Gas Line Relocation',
      description: 'New piping, fixtures, and drainage work required in Melbourne 3000.',
      location: 'Melbourne VIC 3000',
      submittedAt: '2026-01-30T03:00:00.000Z',
      deliveredAt: '2026-01-30T03:01:00.000Z',
      lastUpdated: '2026-01-30T09:14:00.000Z',
      customerId: 'CUS-2187',
      businessId: 'BUS-9934',
      attachmentsSummary: 'Image 1 — Site photo; Image 2 — Existing bathroom layout',
      containsMedia: true,
      quoteRequestStatus: 'Distributed',
      responseStatus: 'Responded',
      snapshot: {
        formRecord: 'Quote Request Form',
        formVersion: 'Version 3',
        quoteTitle: 'Bathroom Gas Line Relocation',
        jobDescription: 'Relocate the existing gas line before the bathroom renovation begins.',
        tradeCategory: 'Plumbing',
        subcategory: 'Gas Fitting',
        jobLocation: 'Melbourne VIC 3000',
        selectedQuoteRadius: '10 km',
        attachments: ['site-photo-1.jpg', 'existing-bathroom-layout.jpg'],
        submittedOn: '2026-01-30T03:00:00.000Z',
      },
      distribution: {
        recipientMatchId: 'QMR-0002',
        matchingRuleId: 'QMD-0001',
        allocationType: 'Pro',
        planAtMatchingTime: 'Pro',
        deliveryStatus: 'Delivered',
        matchingRunOn: '2026-01-30T03:01:00.000Z',
        appliedRuleSettings: {
          conditions: ['Is Plumbing', 'Quote History of 90 days'],
          maximumBusinesses: '5',
          proBusinesses: '3',
          basicBusinesses: '1',
          bestMatch: '1',
          defaultQuoteRadius: '10 km',
          distributionMethod: 'Simultaneous',
        },
      },
    },
    chatMessages: [
      { id: 'QTH-8101', sender: 'Customer', senderId: 'CUS-2187', text: 'Hi, I submitted the form. Please let me know if you need anything else before quoting.', timestamp: '2026-01-30T09:00:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T09:01:00.000Z', visibility: 'Visible', isFlagged: false, isQuoteRequest: true },
      { id: 'QTH-8102', sender: 'Business', senderId: 'BUS-9934', text: 'Thanks for the request. We’re reviewing the job details now.', timestamp: '2026-01-30T09:05:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T09:05:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8103', sender: 'Business', senderId: 'BUS-9934', text: 'I may need one more photo of the existing connection point before I finalise the quote.', timestamp: '2026-01-30T09:06:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T09:06:20.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8104', sender: 'Customer', senderId: 'CUS-2187', text: 'Will upload one more tonight — anything specific you want in frame?', timestamp: '2026-01-30T09:06:45.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T09:07:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8105', sender: 'Business', senderId: 'BUS-9934', text: 'Whole manifold area plus labels if visible — thanks.', timestamp: '2026-01-30T09:07:30.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T09:08:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8106', sender: 'Customer', senderId: 'CUS-2187', text: 'Uploaded two pics — let me know if that works.', timestamp: '2026-01-30T09:10:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T09:10:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8107', sender: 'Business', senderId: 'BUS-9934', text: 'Perfect — that’s enough to quote. I’ll send pricing tomorrow AM.', timestamp: '2026-01-30T09:11:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T09:11:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8108', sender: 'Business', senderId: 'BUS-9934', text: 'Easiest if you pay direct — here’s my mobile 04xx xxx xxx and BSB for deposit.', timestamp: '2026-01-30T09:12:30.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T09:13:00.000Z', visibility: 'Visible', isFlagged: true },
      { id: 'QTH-8109', sender: 'Customer', senderId: 'CUS-2187', text: 'I’d prefer to keep payment through TradesPoster only.', timestamp: '2026-01-30T09:13:15.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T09:13:40.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8110', sender: 'Business', senderId: 'BUS-9934', text: 'Please confirm the date before I attend.', timestamp: '2026-01-30T09:14:00.000Z', direction: 'Business → Customer', messageStatus: 'Delivered', visibility: 'Visible', isFlagged: false },
    ],
    customer: {
      customerId: 'CUS-2187',
      name: 'Sarah Kerr',
      memberSince: '2024-03-15',
      lastActive: '2026-01-30T09:10:00.000Z',
      accountStatus: 'Active',
      blockStatus: 'Not blocked',
    },
    business: {
      businessId: 'BUS-9934',
      businessName: 'Werribee Plumbing Pty Ltd',
      category: 'Plumbing',
      verificationStatus: 'Verified',
      accountStatus: 'Active',
      blockStatus: 'Not blocked',
      memberSince: '2022-08-01',
    },
    flag: {
      flagId: 'FLG-55102',
      source: 'Customer Flag',
      flaggedBy: 'Sarah Kerr',
      quoteThreadId: 'QTH-8108',
      category: 'Moderation',
      trigger: 'Business attempting to move customer off-platform or share contact details for direct payment',
      reason: 'Business attempting to move customer off-platform or share contact details for direct payment',
      severity: 'High',
      status: 'Under Review',
      linkedCaseId: 'MOD-000552',
      createdAt: '2026-01-30T09:15:00.000Z',
      updatedAt: '2026-01-30T09:15:00.000Z',
    },
    case: {
      caseId: 'MOD-000552',
      contentType: 'Quote',
      severity: 'High',
      status: 'New',
      assignedTo: 'Unassigned',
      created: '2026-01-30T09:15:00.000Z',
      updated: '2026-01-30T09:15:00.000Z',
    },
    messagingState: 'Active',
    adminNote: 'Business shared phone and email, requested direct payment in quote chat.',
  },

  // Scenario 3 — Low User Flag, no Moderation case → Active | Profile
  {
    scenarioKey: 3,
    name: 'No Violation / Legitimate Negotiation',
    quote: {
      quoteId: 'QTE-8025',
      quoteRequestId: 'QREQ-8025',
      recipientMatchId: null,
      requestSource: 'Profile',
      title: 'General Plumbing Repair',
      description: 'Leaking kitchen tap, replace cartridge. Point Cook 3030.',
      location: 'Point Cook VIC 3030',
      submittedAt: '2026-01-28T21:00:00.000Z',
      deliveredAt: '2026-01-28T21:01:00.000Z',
      lastUpdated: '2026-01-30T07:34:00.000Z',
      customerId: 'CUS-3349',
      businessId: 'BUS-4412',
      attachmentsSummary: '',
      containsMedia: false,
      quoteRequestStatus: 'Distributed',
      responseStatus: 'Responded',
      snapshot: {
        formRecord: 'Quote Request Form',
        formVersion: 'Version 3',
        quoteTitle: 'General Plumbing Repair',
        jobDescription: 'Leaking kitchen tap, replace cartridge.',
        tradeCategory: 'Plumbing',
        subcategory: 'Repairs',
        jobLocation: 'Point Cook VIC 3030',
        selectedQuoteRadius: null,
        attachments: [],
        submittedOn: '2026-01-28T21:00:00.000Z',
      },
      distribution: {
        recipientMatchId: null,
        matchingRuleId: null,
        allocationType: 'Direct Request',
        planAtMatchingTime: null,
        deliveryStatus: 'Delivered',
        matchingRunOn: null,
        appliedRuleSettings: null,
      },
    },
    chatMessages: [
      { id: 'QTH-8201', sender: 'Customer', senderId: 'CUS-3349', text: 'The quote is a bit above budget. Any room to move?', timestamp: '2026-01-30T07:00:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T07:01:00.000Z', visibility: 'Visible', isFlagged: false, isQuoteRequest: true },
      { id: 'QTH-8202', sender: 'Business', senderId: 'BUS-4412', text: 'We could do a basic fix for less, but warranty would be shorter.', timestamp: '2026-01-30T07:15:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T07:15:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8203', sender: 'Customer', senderId: 'CUS-3349', text: 'Can you split labour vs parts so I can compare with another quote?', timestamp: '2026-01-30T07:16:30.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T07:17:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8204', sender: 'Business', senderId: 'BUS-4412', text: 'Already itemised on page 2 of the PDF — happy to clarify any line.', timestamp: '2026-01-30T07:17:45.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T07:18:00.000Z', visibility: 'Visible', isFlagged: true },
      { id: 'QTH-8205', sender: 'Customer', senderId: 'CUS-3349', text: 'I’ll pass for now. Thanks anyway.', timestamp: '2026-01-30T07:30:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T07:30:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8206', sender: 'Business', senderId: 'BUS-4412', text: 'No problem. Reach out if your requirements change.', timestamp: '2026-01-30T07:32:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T07:32:20.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'QTH-8207', sender: 'Customer', senderId: 'CUS-3349', text: 'Can you attend tomorrow morning?', timestamp: '2026-01-30T07:34:00.000Z', direction: 'Customer → Business', messageStatus: 'Delivered', visibility: 'Visible', isFlagged: false },
    ],
    customer: {
      customerId: 'CUS-3349',
      name: 'Daniel Morris',
      memberSince: '2023-08-01',
      lastActive: '2026-01-30T07:35:00.000Z',
      accountStatus: 'Active',
      blockStatus: 'Not blocked',
    },
    business: {
      businessId: 'BUS-4412',
      businessName: 'RapidFix Plumbing Pty Ltd',
      category: 'Plumbing',
      verificationStatus: 'Verified',
      accountStatus: 'Active',
      blockStatus: 'Not blocked',
      memberSince: '2023-05-12',
    },
    flag: {
      flagId: 'FLG-55103',
      source: 'Business Flag',
      flaggedBy: 'RapidFix Plumbing Pty Ltd',
      quoteThreadId: 'QTH-8204',
      category: 'Moderation',
      trigger: 'Reported — price discussion / declined quote',
      reason: 'Reported — price discussion / declined quote',
      severity: 'Low',
      status: 'Closed',
      linkedCaseId: null,
      createdAt: '2026-01-30T07:40:00.000Z',
      updatedAt: '2026-01-30T07:40:00.000Z',
    },
    case: null,
    messagingState: 'Active',
    adminNote: 'Legitimate price negotiation. Low User Flag only.',
  },
];

function normalizeQuoteIdKey(quoteId) {
  return String(quoteId || '')
    .replace(/^QTE-?/i, '')
    .replace(/^QUOTE-?/i, '');
}

export function getQuoteScenarioByCaseId(caseId) {
  if (!caseId) return null;
  const n = String(caseId).replace(/^(?:MODS|MOA|MOD)-?/i, '');
  return (
    quoteScenarios.find(
      (s) => s.case && String(s.case.caseId).replace(/^(?:MODS|MOA|MOD)-?/i, '') === n
    ) || null
  );
}

export function getQuoteScenarioByQuoteId(quoteId) {
  if (!quoteId) return null;
  const n = normalizeQuoteIdKey(quoteId);
  return quoteScenarios.find((s) => normalizeQuoteIdKey(s.quote.quoteId) === n) || null;
}

function resolveQuoteCaseSource(flag) {
  const source = String(flag?.source || '').toLowerCase();
  if (source.includes('detection')) return 'Detection';
  if (source === 'system' || source.includes('system')) return 'System Signal';
  return 'User Flag';
}

const mapQuoteQueueRow = (s, avatarSeed = 32) => {
  const c = s.case;
  const f = s.flag;
  const title = (s.quote?.title || '').trim();
  const reviewReason = f.reason || f.trigger || '—';
  const caseSource = resolveQuoteCaseSource(f);
  const flagCount = caseSource === 'User Flag' ? 1 : null;
  return {
    caseId: c.caseId,
    contentType: 'Quote',
    preview: title || 'Quote Thread',
    caseSource,
    reviewReason,
    flagReason: reviewReason,
    flagCount,
    priority: c.severity,
    severity: c.severity,
    status: c.status === 'In Review' ? 'Under Review' : c.status,
    assignedTo: c.assignedTo || 'Unassigned',
    created: c.created,
    updated: c.updated,
    quoteId: s.quote.quoteId,
    quoteRequestId: s.quote.quoteRequestId,
    customerId: s.customer.customerId,
    customerName: s.customer.name,
    businessId: s.business.businessId,
    businessName: s.business.businessName,
    accountName: s.business.businessName,
    accountAvatar: `https://i.pravatar.cc/150?img=${avatarSeed}`,
    flagId: f.flagId,
    scenarioKey: s.scenarioKey,
  };
};

/** Moderation Queue — active Medium/High quote cases. */
export function getQuoteQueueCases() {
  return quoteScenarios
    .filter((s) => s.case && [1, 2].includes(s.scenarioKey))
    .map((s) => mapQuoteQueueRow(s, 40 + s.scenarioKey));
}

/**
 * Operational Status priority:
 * Under Review (active Medium/High case) → Blocked → Restricted → Active.
 */
function deriveQuoteRecordStatus(scenario) {
  const caseStatus = scenario.case?.status;
  const severity = scenario.case?.severity;
  const messagingState = scenario.messagingState || 'Active';

  if (
    scenario.case &&
    (caseStatus === 'Under Review' || caseStatus === 'In Review') &&
    (severity === 'Medium' || severity === 'High')
  ) {
    return 'Under Review';
  }
  if (messagingState === 'Blocked') return 'Blocked';
  if (messagingState === 'Restricted') return 'Restricted';
  return 'Active';
}

function latestQuoteThreadPreview(lastMsg) {
  if (!lastMsg) return '—';
  if (lastMsg.fileName) return lastMsg.fileName;
  const rawPreview = (lastMsg.text || '').trim();
  if (!rawPreview) return '—';
  return rawPreview.length > 120 ? `${rawPreview.slice(0, 120)}…` : rawPreview;
}

/** Screen 1 Request Source: Post | Profile | Get Quotes only. */
export function getQuoteRequestSourceDisplay(source) {
  const raw = String(source || '').trim();
  const lower = raw.toLowerCase();
  if (lower.includes('profile')) return 'Profile';
  if (lower === 'post' || lower.includes('post')) return 'Post';
  if (lower.includes('website') || lower.includes('get quote')) return 'Get Quotes';
  if (raw === 'Post' || raw === 'Profile' || raw === 'Get Quotes') return raw;
  return 'Get Quotes';
}

/** Admin Quotes list: one row per parent Quote. */
export function getQuotesForScenarios() {
  return quoteScenarios.map((s) => {
    const c = s.case;
    const f = s.flag;
    const q = s.quote;
    const lastMsg = s.chatMessages[s.chatMessages.length - 1];
    const firstMsg = s.chatMessages[0];
    const preview = latestQuoteThreadPreview(lastMsg);
    const recordStatus = deriveQuoteRecordStatus(s);
    const caseStatus = c
      ? (c.status === 'In Review' ? 'Under Review' : (c.status || 'Under Review'))
      : null;
    const requestSource = getQuoteRequestSourceDisplay(q.requestSource);
    const quoteThreadIds = s.chatMessages.map((m) => m.id);
    const flagsList = f
      ? [{
          flagId: f.flagId,
          source: f.source,
          flaggedBy: f.flaggedBy,
          quoteThreadId: f.quoteThreadId,
          messageThreadId: f.quoteThreadId,
          category: f.category,
          trigger: f.trigger,
          reason: f.reason || f.trigger,
          severity: f.severity,
          status: f.status === 'Under Review' ? 'Under Review' : f.status,
          linkedCaseId: f.linkedCaseId || c?.caseId || null,
          linkedCaseType: f.linkedCaseId || c?.caseId ? 'Moderation' : null,
          createdAt: f.createdAt,
          updatedAt: f.updatedAt,
        }]
      : [];

    return {
      id: q.quoteId,
      quoteId: q.quoteId,
      quoteRequestId: q.quoteRequestId,
      recipientMatchId: q.recipientMatchId || null,
      threadId: q.quoteId,
      conversationId: q.quoteId,
      customer: { name: s.customer.name, id: s.customer.customerId, avatar: 'https://i.pravatar.cc/150?img=32', accountStatus: s.customer.accountStatus },
      business: { name: s.business.businessName, id: s.business.businessId, avatar: 'https://i.pravatar.cc/150?img=65', accountStatus: s.business.accountStatus, verificationStatus: s.business.verificationStatus },
      type: 'Quote',
      quoteTitle: q.title,
      latestMessagePreview: preview,
      latestQuoteThreadPreview: preview,
      latestQuoteThreadStatus: lastMsg?.messageStatus || 'Sent',
      latestDirection: lastMsg?.direction || (firstMsg?.sender === 'Customer' ? 'Customer → Business' : 'Business → Customer'),
      requestSource,
      totalQuoteThreads: s.chatMessages.length,
      flagsCount: flagsList.length,
      quoteThreadIds,
      status: recordStatus,
      listStatus: recordStatus,
      messagingState: s.messagingState || 'Active',
      flagged: flagsList.some((flag) => flag.status === 'Under Review' || flag.status === 'Open'),
      underReview: recordStatus === 'Under Review',
      flagStatus: flagsList.some((flag) => flag.status !== 'Closed' && flag.status !== 'Resolved')
        ? 'Under Review'
        : 'None',
      quoteStatus: recordStatus,
      groupQuoteId: null,
      unreadCount: 0,
      created: q.submittedAt,
      submittedOn: q.submittedAt,
      deliveredOn: q.deliveredAt || q.submittedAt,
      lastActivity: lastMsg?.timestamp || q.submittedAt,
      lastQuoteThreadOn: lastMsg?.timestamp || q.submittedAt,
      lastUpdated: q.lastUpdated || lastMsg?.timestamp || q.submittedAt,
      region: 'VIC',
      tradeCategory: s.business.category || 'Plumbing',
      messageCount: s.chatMessages.length,
      conversationStartedBy: firstMsg?.sender === 'Customer' ? 'Customer' : 'Business',
      moderationCaseId: c?.caseId || null,
      flags: flagsList,
      moderationCases: c
        ? [{ caseId: c.caseId, status: caseStatus, severity: c.severity, assignedTo: c.assignedTo, created: c.created, updated: c.updated }]
        : [],
      caseStatus,
      caseSeverity: c?.severity || null,
      chatMessages: s.chatMessages,
      snapshot: q.snapshot || null,
      distribution: q.distribution || null,
    };
  });
}

/** Confirmed Quote Request Status values for Admin Quote Requests list. */
export const QUOTE_REQUEST_STATUSES = [
  'Submitted',
  'Needs Clarification',
  'Matching Incomplete',
  'No Match',
  'Distributed',
  'Partly Distributed',
  'Not Delivered',
];

/**
 * Additional Quote Requests with no recipient Quote (or incomplete delivery).
 * Invalid drafts are excluded by design.
 */
const standaloneQuoteRequests = [
  {
    quoteRequestId: 'QREQ-8030',
    quoteTitle: 'Kitchen Exhaust Fan Replacement',
    customer: { customerId: 'CUS-4419', name: 'Michael Turner' },
    requestSource: 'Get Quotes',
    requestStatus: 'Needs Clarification',
    submittedOn: '2026-01-31T02:10:00.000Z',
    intendedBusiness: null,
    snapshot: {
      formRecord: 'Quote Request Form',
      formVersion: 'Version 3',
      quoteTitle: 'Kitchen Exhaust Fan Replacement',
      jobDescription: 'Replace noisy rangehood fan. Unsure if electrical or plumbing trade.',
      tradeCategory: 'Plumbing',
      subcategory: null,
      jobLocation: 'Point Cook VIC 3030',
      selectedQuoteRadius: '10 km',
      attachments: [],
      submittedOn: '2026-01-31T02:10:00.000Z',
    },
    clarifications: [],
    outcome: {
      result: 'Needs Clarification',
      explanation: 'Category/service intent is unclear. Customer must clarify Trade Category or Subcategory before matching.',
      assessments: [],
    },
    recipients: [],
  },
  {
    quoteRequestId: 'QREQ-8031',
    quoteTitle: 'Emergency Hot Water Repair',
    customer: { customerId: 'CUS-2187', name: 'Sarah Kerr' },
    requestSource: 'Get Quotes',
    requestStatus: 'No Match',
    submittedOn: '2026-01-31T04:00:00.000Z',
    intendedBusiness: null,
    snapshot: {
      formRecord: 'Quote Request Form',
      formVersion: 'Version 3',
      quoteTitle: 'Emergency Hot Water Repair',
      jobDescription: 'No hot water since this morning. Need same-day inspection if possible.',
      tradeCategory: 'Plumbing',
      subcategory: 'Hot Water',
      jobLocation: 'Hoppers Crossing VIC 3029',
      selectedQuoteRadius: '10 km',
      attachments: ['hot-water-unit.jpg'],
      submittedOn: '2026-01-31T04:00:00.000Z',
    },
    clarifications: [
      {
        clarificationId: 'QCL-1001',
        customerName: 'Sarah Kerr',
        customerId: 'CUS-2187',
        submittedOn: '2026-01-31T04:20:00.000Z',
        formVersion: 'Version 3',
        changedValues: {
          subcategory: 'Hot Water',
          jobDescription: 'No hot water since this morning. Storage tank unit in laundry.',
        },
        usedForSending: true,
      },
    ],
    outcome: {
      result: 'No Match',
      explanation: 'Website assessment completed. No eligible Business within the selected radius and Quote Interests.',
      assessments: [
        {
          ruleId: 'QMD-0001',
          assessedOn: '2026-01-31T04:22:00.000Z',
          appliedRuleSettings: {
            conditions: ['Is Plumbing', 'Quote History of 90 days'],
            maximumBusinesses: '5',
            proBusinesses: '3',
            basicBusinesses: '1',
            bestMatch: '1',
            defaultQuoteRadius: '10 km',
            distributionMethod: 'Simultaneous',
          },
        },
      ],
    },
    recipients: [],
  },
  {
    quoteRequestId: 'QREQ-8032',
    quoteTitle: 'Bathroom Tile Repair',
    customer: { customerId: 'CUS-3349', name: 'Daniel Morris' },
    requestSource: 'Get Quotes',
    requestStatus: 'Partly Distributed',
    submittedOn: '2026-01-31T06:00:00.000Z',
    intendedBusiness: null,
    snapshot: {
      formRecord: 'Quote Request Form',
      formVersion: 'Version 3',
      quoteTitle: 'Bathroom Tile Repair',
      jobDescription: 'Cracked wall tiles around shower niche. Quote for repair or partial re-tile.',
      tradeCategory: 'Plumbing',
      subcategory: 'Bathroom',
      jobLocation: 'Werribee VIC 3030',
      selectedQuoteRadius: '20 km',
      attachments: ['shower-niche.jpg'],
      submittedOn: '2026-01-31T06:00:00.000Z',
    },
    clarifications: [],
    outcome: {
      result: 'Partly Distributed',
      explanation: 'Final recipient group fixed. One Business received the Request; one delivery failed after selection.',
      assessments: [
        {
          ruleId: 'QMD-0001',
          assessedOn: '2026-01-31T06:02:00.000Z',
          appliedRuleSettings: {
            conditions: ['Is Plumbing', 'Quote History of 90 days'],
            maximumBusinesses: '5',
            proBusinesses: '3',
            basicBusinesses: '1',
            bestMatch: '1',
            defaultQuoteRadius: '20 km',
            distributionMethod: 'Simultaneous',
          },
        },
      ],
    },
    recipients: [
      {
        businessId: 'BUS-6027',
        businessName: 'PrimeFlow Plumbing',
        deliveryResult: 'Delivered',
        deliveredOn: '2026-01-31T06:03:00.000Z',
        quoteId: null,
      },
      {
        businessId: 'BUS-9901',
        businessName: 'QuickFlow Plumbing',
        deliveryResult: 'Failed',
        deliveredOn: null,
        quoteId: null,
      },
    ],
  },
  {
    quoteRequestId: 'QREQ-8033',
    quoteTitle: 'Blocked Stormwater Pipe',
    customer: { customerId: 'CUS-4419', name: 'Michael Turner' },
    requestSource: 'Profile',
    requestStatus: 'Not Delivered',
    submittedOn: '2026-01-31T08:00:00.000Z',
    intendedBusiness: { businessId: 'BUS-4412', businessName: 'RapidFix Plumbing Pty Ltd' },
    snapshot: {
      formRecord: 'Quote Request Form',
      formVersion: 'Version 3',
      quoteTitle: 'Blocked Stormwater Pipe',
      jobDescription: 'Stormwater pit overflowing after rain. Request sent to RapidFix from their profile.',
      tradeCategory: 'Plumbing',
      subcategory: 'Drainage',
      jobLocation: 'Point Cook VIC 3030',
      selectedQuoteRadius: null,
      attachments: [],
      submittedOn: '2026-01-31T08:00:00.000Z',
    },
    clarifications: [],
    outcome: {
      result: 'Not Delivered',
      explanation: 'Direct Business became unavailable after valid submission. No recipient Quote was created.',
      assessments: [],
    },
    recipients: [
      {
        businessId: 'BUS-4412',
        businessName: 'RapidFix Plumbing Pty Ltd',
        deliveryResult: 'Not Delivered',
        deliveredOn: null,
        quoteId: null,
      },
    ],
  },
  {
    quoteRequestId: 'QREQ-8034',
    quoteTitle: 'Outdoor Tap Installation',
    customer: { customerId: 'CUS-2187', name: 'Sarah Kerr' },
    requestSource: 'Get Quotes',
    requestStatus: 'Matching Incomplete',
    submittedOn: '2026-01-31T09:30:00.000Z',
    intendedBusiness: null,
    snapshot: {
      formRecord: 'Quote Request Form',
      formVersion: 'Version 3',
      quoteTitle: 'Outdoor Tap Installation',
      jobDescription: 'Install one outdoor tap on side fence line.',
      tradeCategory: 'Plumbing',
      subcategory: 'Taps',
      jobLocation: 'Hoppers Crossing VIC 3029',
      selectedQuoteRadius: '10 km',
      attachments: [],
      submittedOn: '2026-01-31T09:30:00.000Z',
    },
    clarifications: [],
    outcome: {
      result: 'Matching Incomplete',
      explanation: 'Website matching could not finish because a usable applicable Rule was unavailable.',
      assessments: [],
    },
    recipients: [],
  },
  {
    quoteRequestId: 'QREQ-8035',
    quoteTitle: 'Toilet Cisern Replacement',
    customer: { customerId: 'CUS-3349', name: 'Daniel Morris' },
    requestSource: 'Get Quotes',
    requestStatus: 'Submitted',
    submittedOn: '2026-01-31T10:15:00.000Z',
    intendedBusiness: null,
    snapshot: {
      formRecord: 'Quote Request Form',
      formVersion: 'Version 3',
      quoteTitle: 'Toilet Cisern Replacement',
      jobDescription: 'Replace dual-flush cistern. Access via laundry.',
      tradeCategory: 'Plumbing',
      subcategory: 'Toilets',
      jobLocation: 'Werribee VIC 3030',
      selectedQuoteRadius: '10 km',
      attachments: [],
      submittedOn: '2026-01-31T10:15:00.000Z',
    },
    clarifications: [],
    outcome: {
      result: 'Submitted',
      explanation: 'Accepted. Assessment or delivery is pending.',
      assessments: [],
    },
    recipients: [],
  },
];

function buildRequestFromScenario(s) {
  const q = s.quote;
  const isDirect = getQuoteRequestSourceDisplay(q.requestSource) === 'Profile';
  const distribution = q.distribution || {};
  const recipients = [
    {
      businessId: s.business.businessId,
      businessName: s.business.businessName,
      deliveryResult: distribution.deliveryStatus || 'Delivered',
      deliveredOn: q.deliveredAt || null,
      quoteId: q.quoteId,
    },
  ];

  return {
    quoteRequestId: q.quoteRequestId,
    quoteTitle: q.title,
    customer: { customerId: s.customer.customerId, name: s.customer.name },
    requestSource: getQuoteRequestSourceDisplay(q.requestSource),
    requestStatus: q.quoteRequestStatus || 'Distributed',
    submittedOn: q.submittedAt,
    intendedBusiness: isDirect
      ? { businessId: s.business.businessId, businessName: s.business.businessName }
      : null,
    snapshot: q.snapshot || null,
    clarifications: q.clarifications || [],
    outcome: q.outcome || {
      result: q.quoteRequestStatus || 'Distributed',
      explanation: isDirect
        ? 'Direct Business Profile Request delivered to the intended Business.'
        : 'Every Business in the final recipient group successfully received the Request.',
      assessments:
        distribution.matchingRuleId
          ? [
              {
                ruleId: distribution.matchingRuleId,
                assessedOn: distribution.matchingRunOn,
                appliedRuleSettings: distribution.appliedRuleSettings || null,
              },
            ]
          : [],
    },
    recipients,
  };
}

/** Admin Quote Requests list: one row per submitted Request. */
export function getQuoteRequestsForScenarios() {
  const fromQuotes = quoteScenarios.map(buildRequestFromScenario);
  const byId = new Map();
  fromQuotes.forEach((row) => {
    const existing = byId.get(row.quoteRequestId);
    if (!existing) {
      byId.set(row.quoteRequestId, row);
      return;
    }
    // Same Request with multiple recipient Quotes — merge recipients once
    const seen = new Set((existing.recipients || []).map((r) => r.quoteId || r.businessId));
    (row.recipients || []).forEach((r) => {
      const key = r.quoteId || r.businessId;
      if (!seen.has(key)) {
        existing.recipients.push(r);
        seen.add(key);
      }
    });
  });
  standaloneQuoteRequests.forEach((row) => {
    if (!byId.has(row.quoteRequestId)) {
      byId.set(row.quoteRequestId, {
        ...row,
        requestSource: getQuoteRequestSourceDisplay(row.requestSource),
      });
    }
  });
  return Array.from(byId.values()).sort(
    (a, b) => new Date(b.submittedOn).getTime() - new Date(a.submittedOn).getTime()
  );
}

export function getQuoteRequestById(requestId) {
  if (!requestId) return null;
  const id = String(requestId).trim().toUpperCase();
  return (
    getQuoteRequestsForScenarios().find(
      (r) => String(r.quoteRequestId || '').toUpperCase() === id
    ) || null
  );
}

export default quoteScenarios;
